<template>
  <div class="d-flex mr-3" v-if="hasUnpublished">

    <div
      class="alert alert-danger mb-0 py-1 px-2 text-bold"
      title="Click to Review and Publish"
      @click="$router.push({name: 'menusPublish'})"
    >
      {{ unpublishedLocations.length }} Location{{ this.unpublishedLocations.length === 1 ? '' : 's'}} pending publish
    </div>
    <MenusPublishSync/>
  </div>
</template>

<script>
import MenusPublishSync from '@/common/elements/config-publish/MenusPublishSync'
import { mapActions, mapGetters, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'NavigationTopPublishStatus',
  components: { MenusPublishSync },
  data: () => ({
    hasShowUnpublishedWarn: false
  }),
  computed: {
    ...mapGetters('menuPublish', ['locationsData', 'hasUnpublished', 'unpublishedLocations']),
    ...mapState('login', ['user']),
    userCompanyId () {
      return _.get(this.user, 'userCompanyId')
    }
  },
  watch: {
    userCompanyId: {
      async handler (userCompanyId) {
        if (userCompanyId) {
          await this.retrieveData('menu')
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('menuPublish', ['retrieveData'])
  }
}
</script>

<style lang="scss" scoped>
  .alert {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
